// removed by extract-text-webpack-plugin
module.exports = {"container":"event-details__container__1u7wb","header":"event-details__header__27UkM","paragraph":"event-details__paragraph__eruvY","calendar-link":"event-details__calendar-link__1fzQY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/event-details.scss
// module id = 1336
// module chunks = 1